import { TEMPORARY_REGISTRATION_ADMIN } from "redux/constants/admin/masterdata/constants";

const initialState = {
  loadingGetTemporaryRegistration: true,
  actionLoadingTemporaryRegistration: false,
  dataTemporaryRegistration: { count: 0, data: [] },
};

export const temporaryRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEMPORARY_REGISTRATION_ADMIN.GET_DATA_TEMPORARY_REGISTRATION_SUCCESS:
      return {
        ...state,
        dataTemporaryRegistration: action.data,
      };
    case TEMPORARY_REGISTRATION_ADMIN.LOADING_DATA_TEMPORARY_REGISTRATION_SUCCESS:
      return {
        ...state,
        loadingGetTemporaryRegistration: action.load,
      };
    case TEMPORARY_REGISTRATION_ADMIN.LOADING_ACTION_TEMPORARY_REGISTRATION:
      return {
        ...state,
        actionLoadingTemporaryRegistration: action.load,
      };
    default:
      return state;
  }
};